import EditDevice from "./EditDevice";

export default EditDevice